import React, { useState } from "react";
import { Button } from "../ui/button";
import { BehaviorEntry } from "../../types/tradingJournal";
import { useTradeJournal } from "../../context/TradeJournalContext";
import { BrainCircuit, PlusCircle } from "lucide-react";
import BehaviorJournalForm from "./BehaviorJournalForm";
import BehaviorMetricsCards from "./BehaviorMetricsCards";
import BehaviorCharts from "./BehaviorCharts";
import BehaviorRecommendationsCard from "./BehaviorRecommendationsCard";
import BehaviorEntriesTable from "./BehaviorEntriesTable";
import TradingJournalStats from "./TradingJournalStats";
import TradeInsights from "./TradeInsights";

const BehaviorView = () => {
  const {
    entries,
    behaviorEntries,
    behaviorCorrelations,
    behaviorRecommendations,
    filteredBehaviorEntries,
    stats,
  } = useTradeJournal();
  const [showForm, setShowForm] = useState(false);
  const [editingEntry, setEditingEntry] = useState<BehaviorEntry | null>(null);

  const handleEditEntry = (entry: BehaviorEntry) => {
    setEditingEntry(entry);
    setShowForm(true);
  };

  const handleFormSubmit = () => {
    setShowForm(false);
    setEditingEntry(null);
  };

  const handleAddEntry = () => {
    setEditingEntry(null);
    setShowForm(true);
  };

  return (
    <div className="space-y-6">
      {showForm ? (
        <BehaviorJournalForm
          onSubmit={handleFormSubmit}
          editingEntry={editingEntry}
        />
      ) : (
        <>
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
            <div>
              <h2 className="text-xl font-semibold flex items-center gap-2">
                <BrainCircuit className="h-5 w-5 text-market-teal" />
                Trading Psychology Tracker
              </h2>
              <p className="text-white/60 text-sm">
                Track your trading behavior patterns and their impact on
                performance
              </p>
            </div>

            <Button
              onClick={handleAddEntry}
              className="intellectia-button text-black flex items-center gap-2"
            >
              <PlusCircle className="h-4 w-4" />
              Add Today's Journal
            </Button>
          </div>

          <TradingJournalStats />

          <BehaviorMetricsCards
            filteredBehaviorEntries={filteredBehaviorEntries}
          />

          <BehaviorCharts
            filteredBehaviorEntries={filteredBehaviorEntries}
            behaviorCorrelations={behaviorCorrelations}
          />

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="h-full">
              <TradeInsights
                entries={entries}
                behaviorEntries={filteredBehaviorEntries}
              />
            </div>

            <div className="h-full">
              <BehaviorRecommendationsCard
                behaviorRecommendations={behaviorRecommendations}
                onAddEntry={handleAddEntry}
              />
            </div>
          </div>

          <BehaviorEntriesTable
            filteredBehaviorEntries={filteredBehaviorEntries}
            onEditEntry={handleEditEntry}
            onAddEntry={handleAddEntry}
          />
        </>
      )}
    </div>
  );
};

export default BehaviorView;
